import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const WarmupToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.div`
  font-family: Lato;
  font-size: 15px;
  color: ${darkgrey};
  font-weight: 400;
  line-height: 21px;
`;
